<script setup lang="ts"></script>

<template>
  <i18n-t
    keypath="calculators.personal-date.full-day-report.calendar-warning"
    tag="div"
    class="p-3 bg-white rounded-lg border border-divider text-xs text-alternative-gray leading-relaxed"
  >
    <template #status>
      <strong class="text-brown">
        {{
          $t("calculators.personal-date.full-day-report.status-inauspicious")
        }}
      </strong>
    </template>
  </i18n-t>
</template>
